function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".socialProof_svg__cls-1{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "socialProof_svg__cls-1",
  d: "M542 1094.21c-136.56-.06-179.27-2.83-218.52-8.63C202.79 1067.82 131.16 996 116.34 878c-12.49-99.41-12.43-135-12.34-199.67v-39.45c-.11-64.64-.17-100.25 12.32-199.66 14.82-118 86.45-189.82 207.12-207.58 39.24-5.8 82-8.57 218.5-8.63 21.95 0 41.45.09 58.87.24a11.74 11.74 0 01-.1 23.47h-.1c-17.36-.15-36.8-.24-58.67-.24-135.08.05-177 2.75-215.07 8.38-110.7 16.28-173.71 79.3-187.27 187.28-12.3 97.94-12.24 133-12.13 196.7v39.53c-.11 63.69-.17 98.77 12.13 196.71 13.56 108 76.57 171 187.26 187.29 38.1 5.63 80 8.32 215.09 8.38s177-2.75 215.07-8.38c110.7-16.29 173.7-79.31 187.26-187.29 12.31-97.94 12.24-133 12.14-196.71v-39.5c0-15.2 0-28.79-.1-42A11.73 11.73 0 01967.94 585c6.54-.4 11.79 5.12 11.86 11.6.15 13.32.13 27 .1 42.31v39.42c.1 64.67.17 100.26-12.31 199.67-14.83 118-86.45 189.82-207.13 207.58-39.24 5.8-81.94 8.57-218.46 8.63z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  className: "socialProof_svg__cls-1",
  cx: 880.89,
  cy: 320.9,
  r: 215.11
});

function SvgSocialProof(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "socialProof_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 1200 1200"
  }, props), _ref, _ref2, _ref3);
}

export default SvgSocialProof;